import { Box, Grid, Typography } from '@mui/material'
import { TooltipContentProps } from 'recharts'
import { CompanyInstagramInsgihtChartData } from './CompanyInstagramInsightChart'
import { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent'

type Props = {
  props: TooltipContentProps<ValueType, NameType>
  data: CompanyInstagramInsgihtChartData
  yAxisLabel: string
  showProfileViews: boolean
  showFollowerCount: boolean
}

export const CompanyInstagramInsightTooltip: React.FC<Props> = ({
  props,
  data,
  yAxisLabel,
  showProfileViews,
  showFollowerCount,
}) => {
  if (!props.payload?.[0]?.payload) return null

  const current = props.payload[0].payload
  const prev = data.findLast((d) => d.date < current.date)

  const followerDiff = prev ? current.followerCount - prev.followerCount : 0
  const followerChange = followerDiff > 0 ? `+${followerDiff}` : followerDiff

  const viewDiff = prev ? current.value - prev.value : 0
  const viewChange = viewDiff > 0 ? `+${viewDiff}` : viewDiff

  return (
    <Box
      maxWidth={240}
      sx={{
        backgroundColor: 'white',
        py: 1,
        px: 2,
        border: '1px solid lightgray',
        borderRadius: '4px',
      }}
    >
      <Grid container spacing={1}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="body2" sx={{ fontWeight: 'bold', color: 'primary.dark' }}>
            {current.date}
          </Typography>
        </Grid>
        {showProfileViews && (
          <>
            <Grid size={{ xs: 10 }}>
              <Typography variant="body2">{yAxisLabel}</Typography>
            </Grid>
            <Grid size={{ xs: 2 }}>
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                {current.value ?? 0}
              </Typography>
            </Grid>
            {prev && (
              <>
                <Grid size={{ xs: 10 }}>
                  <Typography variant="body2" color="text.secondary">
                    {yAxisLabel}前日比
                  </Typography>
                </Grid>
                <Grid size={{ xs: 2 }}>
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 'bold',
                      color: viewDiff > 0 ? 'success.main' : viewDiff < 0 ? 'error.main' : 'text.primary',
                    }}
                  >
                    {viewChange}
                  </Typography>
                </Grid>
              </>
            )}
          </>
        )}
        {showFollowerCount && (
          <>
            <Grid size={{ xs: 10 }}>
              <Typography variant="body2">フォロワー数</Typography>
            </Grid>
            <Grid size={{ xs: 2 }}>
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                {current.followerCount ?? 0}
              </Typography>
            </Grid>
            {prev && (
              <>
                <Grid size={{ xs: 10 }}>
                  <Typography variant="body2" color="text.secondary">
                    フォロワー数前日比
                  </Typography>
                </Grid>
                <Grid size={{ xs: 2 }}>
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 'bold',
                      color: followerDiff > 0 ? 'success.main' : followerDiff < 0 ? 'error.main' : 'text.primary',
                    }}
                  >
                    {followerChange}
                  </Typography>
                </Grid>
              </>
            )}
          </>
        )}
      </Grid>
    </Box>
  )
}
